<template>
  <v-card tile flat>
    <v-card-title class="py-2">
      <v-spacer></v-spacer>
      <v-btn small icon flat @click="previousYear">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <div>{{ selectedYear }}</div>
      <v-btn small icon flat @click="nextYear">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-layout row class="py-2">
      <!--  TOTAL INVOICES -->
      <v-flex xs3 pr-2 d-flex>
        <v-hover>
          <v-card
            width="100%"
            class="elevation-2"
            slot-scope="{ hover }"
            :to="{
              name: 'company',
              params: {},
            }"
          >
            <v-card-title class="pb-2">
              <span class="primary--text">Total Invoices</span>
            </v-card-title>

            <v-card-text class="pt-0">
              <!-- SUPPLIER NAME -->
              <h4 class="truncated-text">
                {{
                  inCurrencyFromId(
                    currencyId,
                    companyBalanceInfo.total_invoices
                      ? companyBalanceInfo.total_invoices
                      : 0
                  )
                }}
              </h4>
              <!-- SUPPLIER City and Country + Flag -->
              <v-label>
                Largest Invoice Amount:
                <strong>{{
                  inCurrencyFromId(
                    currencyId,
                    companyBalanceInfo.biggest_invoice
                      ? companyBalanceInfo.biggest_invoice.amount
                      : 0
                  )
                }}</strong></v-label
              >
              <v-label>
                <br />

                {{
                  companyBalanceInfo.biggest_invoice
                    ? companyBalanceInfo.biggest_invoice.designation
                    : "No invoices for year " + selectedYear
                }}
              </v-label>
            </v-card-text>
            <v-expand-transition>
              <div
                v-if="hover"
                class="d-flex transition-fast-in-fast-out white text-xs-center v-card--reveal"
                style="height: 100%; opacity: 1"
              >
                <v-layout row wrap align-center justify-center>
                  <span class="primary--text">
                    <v-icon class="pr-2" small color="primary"
                      >mdi-arrow-right-circle</v-icon
                    >Go to Accounting/Invoice Tab
                  </span>
                </v-layout>
              </div>
            </v-expand-transition>
          </v-card>
        </v-hover>
      </v-flex>

      <!-- OVERALL PROGRESS OF ALL EXPEDITIONS -->
      <v-flex xs3 pr-2 d-flex>
        <v-card class="elevation-2" dark color="ctcGreen">
          <v-card-title class="pb-0">
            <span class="white--text">Profit and Return On Investment On Contracts</span>
          </v-card-title>

          <v-card-text class="pt-0">
            <v-layout row justify-center align-center>
              <v-flex xs9>
                <v-label dark>Total Profit</v-label>
                <br />
                <span class="headline">{{
                  inCurrencyFromId(
                    currencyId,
                    companyBalanceInfo.contracts_net_profit
                  )
                }}</span>
              </v-flex>

              <v-flex xs3 justify-center align-end class="text-xs-center">
                <v-progress-circular
                  size="70"
                  :indeterminate="loading"
                  :value="
                    companyBalanceInfo.contracts_net_profit
                      ? companyBalanceInfo.contracts_profitability_percent
                      : 0
                  "
                >
                  <div style="line-height: 13px">
                    <v-label dark>ROI</v-label> <br />{{
                      companyBalanceInfo.contracts_net_profit
                        ? companyBalanceInfo.contracts_profitability_percent
                        : 0
                    }}%
                  </div>
                </v-progress-circular>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- PREVISIONAL PROFIT -->
      <v-flex xs3 pr-2 d-flex>
        <v-card class="elevation-2" dark color="ctcGreen">
          <v-card-title class="pb-0">
            <span class="white--text">Provisional Profit on Contracts without Invoices</span>
          </v-card-title>

          <v-card-text class="pt-0">
            <v-layout row align-center pt-2>
              <v-flex xs9>
                <v-label dark>Provisional Profit</v-label>
                <br />
                <span class="headline">{{
                  inCurrencyFromId(
                    currencyId,
                    companyBalanceInfo.provisional_profit
                  )
                }}</span>
              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>


      <!-- PROFITABILITY -->
      <v-flex xs3 pr-2 d-flex>
        <v-card class="elevation-2" dark color="amber darken-2">
          <v-card-title class="pb-0">
            <span class="white--text">Potential Annual Return On Capital</span>
          </v-card-title>

          <v-card-text class="pt-0">
            <v-layout row justify-center align-center>
              <v-flex xs9>
                <v-label dark>Financial XIRR</v-label>
              </v-flex>

              <v-flex xs3 pt-2 justify-center align-end class="text-xs-center">
                <v-progress-circular
                  size="70"
                  :value="companyBalanceInfo.yearly_capital_rentability"
                  :indeterminate="loading"
                >
                  <div style="line-height: 13px">{{companyBalanceInfo.yearly_capital_rentability}}%</div>
                </v-progress-circular>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout wrap row class="py-2">
      <v-flex xs12>
        <companyPaymentDelayOverview
          :invoices="invoicesOfTheYear"
          :selectedYear="selectedYear"
        >
          <v-layout row wrap align-center v-if="!loading">
            <v-flex xs12>
              <apexchart
                width="100%"
                height="200px"
                :options="invoicesSeriesOptions"
                :series="invoicesSeries"
              />
            </v-flex>
          </v-layout>

          <div class="pa-4 text-xs-center" v-if="loading">
            <looping-rhombuses-spinner
              style="margin: auto"
              class="text-xs-center"
              :animation-duration="1000"
              :size="74"
              color="#1976d2"
            />
            <h3 class="title font-weight-light my-2">Loading Chart...</h3>
            <span class="caption grey--text">Please wait</span>
          </div>
        </companyPaymentDelayOverview>
      </v-flex>
    </v-layout>

    <v-layout style="padding-top: 400px"></v-layout>
  </v-card>
</template>
<script>
import apexchart from "vue-apexcharts";
import { mapGetters } from "vuex";
import JsonViewer from "vue-json-viewer";
import currency from "../../../mixins/currency.js";
import date from "../../../mixins/date.js";
import COMPANY_BALANCE_INFO from "../../../graphql/company_balances/show_info.gql";
import { LoopingRhombusesSpinner } from "epic-spinners";
import companyPaymentDelayOverview from "./companyPaymentDelayOverview";

export default {
  name: "companyAccountDashboard",
  components: {
    apexchart,
    LoopingRhombusesSpinner,
    companyPaymentDelayOverview,
    JsonViewer,
  },
  mixins: [currency, date],
  props: {
    invoices: {
      type: Array,
      required: true,
    },
    transactions: {
      type: Array,
      required: true,
    },
    companyName: {
      type: String,
      required: false,
      default: "",
    },
    currencyId: {
      type: String,
      required: true,
    },
    companyBalance: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      selectedYear: new Date().getFullYear(),
      companyBalanceInfo: { biggest_invoice: {} },
      invoicesSeriesOptions: {
        tooltip: {
          shared: true,
          followCursor: true,
          distributed: true,
        },

        yaxis: {
          labels: {
            formatter: this.formatterCurrency,
          },
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [],
        },
        chart: {
          height: 200,
          type: "bar",
          stacked: true,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
        },

        xaxis: {
          type: "datetime",
        },
      },
    };
  },
  computed: {
    invoicesOfTheYear() {
      return this.invoices.filter((inv) => {
        return parseInt(inv.invoice_date) == this.selectedYear;
      });
    },
    invoicesSeries() {
      var invoicesRemainingAmountArr = [];
      var invoicesAmountReconciledArr = [];
      this.invoicesOfTheYear
        .sort((a, b) => (a.invoice_date > b.invoice_date ? 1 : -1))
        .forEach((inv) => {
          invoicesRemainingAmountArr.push({
            x: inv.invoice_date,
            y: inv.amount - inv.reconciliated_amount,
          });

          invoicesAmountReconciledArr.push({
            x: inv.invoice_date,
            y: inv.reconciliated_amount,
          });
        });

      var retArr = [
        {
          name: "Paid Amount",
          data: invoicesAmountReconciledArr,
          color: "#008ffb",
          type: "bar",
        },
        {
          name: "Remaining Amount",
          data: invoicesRemainingAmountArr,
          color: "#e30033",
          type: "bar",
        },
      ];

      return retArr;
    },
  },
  methods: {
    formatterCurrency(val, a) {

      return this.inCurrencyFromId(this.currencyId, val);
    },
    fetchData() {
      this.loading = true;
      this.queryCompanyBalanceInfo();
    },
    queryCompanyBalanceInfo() {
      this.sendQuery(COMPANY_BALANCE_INFO, {
        id: this.companyBalance.id,
        year: this.selectedYear,
      })
        .then((data) => {
          this.loading = false;
          this.companyBalanceInfo = data.company_balance;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    nextYear() {
      this.selectedYear += 1;
      this.fetchData();
    },
    previousYear() {
      this.selectedYear -= 1;
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {},
};
</script>

